'use client';

import { useEffect } from 'react';
import { usePrivy } from '@privy-io/react-auth';
import { getPendingReferralCode } from '@/app/lib/pending-referral';
import { applyPendingReferralForUser } from '@/app/lib/apply-pending-referral';

/**
 * After login, if the user opened a /referral/[code] link first, verify + bind referer.
 */
export default function PendingReferralBinder() {
  const { ready, authenticated, user } = usePrivy();

  useEffect(() => {
    if (!ready || !authenticated || !user?.id) return;
    if (!getPendingReferralCode()) return;

    let cancelled = false;

    (async () => {
      await applyPendingReferralForUser(user.id);
      if (cancelled) return;
    })();

    return () => {
      cancelled = true;
    };
  }, [ready, authenticated, user?.id]);

  return null;
}
